import React, { useState } from "react";
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  Paper,
  CssBaseline,
  useTheme,
} from "@mui/material";
import { Visibility, VisibilityOff, Login } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useAlert from "../../../globalComponents/useAlerts";
import { useForm } from "react-hook-form";
import useLogin from "./useLogin";
import { isDocumentValid, sleep } from "../../../functions";
import {
  DocumentInput,
  TextFieldPasswordComponent,
} from "../../../components/misc/form";

const LoginScreen = () => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const theme = useTheme();
  const navigate = useNavigate();
  const { showAlert, showLoading, dismissLoading } = useAlert();
  const { handleSubmit: formSubmit, control } = useForm();

  const { authenticate } = useLogin();

  const showPassInfo = () => {
    showAlert({
      title: "Lembrete de Senha",
      description:
        "Sua senha é a data de nascimento cadastrada, somente os números. Procure a loja para demais informações",
    });
  };

  const onLoggin = async ({ username: nUser, password }) => {
    try {
      showLoading();

      const username = nUser.replace(/\D/g, "");

      if (!isDocumentValid(username) || password.length < 3)
        throw new Error("Acesso inválido!");

      const user = await authenticate({
        username,
        password,
      });

      await sleep(1500);
      if (!user) throw new Error("Acesso negado!");
      dismissLoading();
      setTimeout(function () {
        navigate("/customer", { replace: true });
      }, 1000);
    } catch (e) {
      await sleep(1500);
      showAlert({ title: "Acesso", description: e.message });
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#f5f5f5", // Fundo cinza claro para destacar o card
      }}
    >
      <CssBaseline />

      {/* Header Colorido (Identidade da Marca) */}
      <Box sx={{ height: "15vh", bgcolor: "#fbb016" }} />

      <Container maxWidth="xs" sx={{ mt: -8, flexGrow: 1 }}>
        <Paper
          elevation={4}
          sx={{
            p: 4,
            borderRadius: 4,
            textAlign: "center",
            bgcolor: "white",
          }}
        >
          {/* Logo Simulado */}
          <Box
            component="img"
            src="logo-fideliza.png" // Substitua pelo seu asset real
            alt="JS Fideliza Logo"
            sx={{ width: "100%", maxWidth: 200, mb: 4 }}
          />

          <Typography
            variant="h6"
            fontWeight="700"
            color="text.primary"
            gutterBottom
          >
            Bem-vindo(a)!
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Acesse sua conta para gerenciar seus pontos.
          </Typography>

          {/* Formulário */}
          <Box component="form" onSubmit={formSubmit(onLoggin)}>
            <DocumentInput
              name="username"
              placeholder="000.000.000-00"
              control={control}
              fullWidth
              required
            />

            <TextFieldPasswordComponent
              name="password"
              label="Senha"
              control={control}
              fullWidth
              required
              size="medium"
              margin="normal"
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              size="large"
              startIcon={<Login />}
              sx={{
                mt: 4,
                py: 1.5,
                borderRadius: 2,
                bgcolor: "#fbb016",
                fontWeight: "bold",
                fontSize: "1rem",
                "&:hover": {
                  bgcolor: "#e69d00",
                  boxShadow: 4,
                },
              }}
            >
              ACESSAR
            </Button>

            <Button
              onClick={showPassInfo}
              fullWidth
              variant="text"
              sx={{ mt: 2, color: "text.secondary", fontWeight: 600 }}
            >
              Esqueci minha senha
            </Button>
          </Box>
        </Paper>
      </Container>

      {/* Footer Cinza */}
      <Box sx={{ py: 3, bgcolor: "#424242", textAlign: "center", mt: "auto" }}>
        <Typography variant="caption" color="rgba(255,255,255,0.5)">
          © {new Date().getFullYear()} JS Construções - Programa Fideliza. Todos
          os direitos reservados.
        </Typography>
      </Box>
    </Box>
  );
};

export default LoginScreen;
